import "@lottiefiles/lottie-player"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
})
